import { useCallback } from 'react'
import { useGlobalToast } from 'transfix-ui/components/Toast'
import { Maybe, ICreateOutboundFilesInput, ICreateOutboundFilesReport } from 'types/graphqlTypes'
import { useStagingTestingCreateOutboundFilesMutation } from '../graphql/StagingTestingCreateOutboundFiles'

export const useStagingTestingCreateOutboundFiles = () => {
  const [createFilesMutation] = useStagingTestingCreateOutboundFilesMutation()

  const { openToast } = useGlobalToast()

  const createOutboundFiles = useCallback(
    async (input: ICreateOutboundFilesInput): Promise<Maybe<ICreateOutboundFilesReport>> => {
      try {
        const response = await createFilesMutation({
          variables: {
            input,
          },
        })

        const { data } = response || {}
        const { stagingTestingCreateOutboundFiles } = data || {}
        const { errors = [], createOutboundFilesReport } = stagingTestingCreateOutboundFiles || {}

        const filteredErrors = errors.filter(item => !!item.message).map(i => i.message)

        const { errorMessage, success } = createOutboundFilesReport || {}

        if (!success) {
          openToast({
            toastMessage: `${filteredErrors.join(', ')} ${errorMessage}` || 'Unknown error occured',
            toastType: 'alert',
          })
        } else {
          openToast({
            toastMessage: 'Outbound file(s) created successfully',
            toastType: 'default',
          })
        }
        return createOutboundFilesReport
      } catch (e) {
        openToast({ toastMessage: e.message, toastType: 'alert' })
        return undefined
      }
    },
    [createFilesMutation, openToast]
  )

  return { createOutboundFiles }
}
